import { gql } from '@apollo/client';
import React from 'react';
import {
  CarouselPumoModuleSlider,
  CAROUSEL_PUMO_MODULE_SLIDER_FRAGMENT
} from '../CarouselPumoModuleSlider';
import {
  CarouselPumoModuleGrid,
  CAROUSEL_PUMO_MODULE_GRID_FRAGMENT
} from '../CarouselPumoModuleGrid';
import { CarouselPumoModuleFragment } from '../../generated/types/CarouselPumoModuleFragment';

export const CAROUSEL_PUMO_MODULE_FRAGMENT = gql`
  fragment CarouselPumoModuleFragment on CarouselPumoModule {
    id
    layoutType
    ...CarouselPumoModuleSliderFragment
    ...CarouselPumoModuleGridFragment
  }
  ${CAROUSEL_PUMO_MODULE_SLIDER_FRAGMENT}
  ${CAROUSEL_PUMO_MODULE_GRID_FRAGMENT}
`;

interface Props {
  carouselPumoModule: CarouselPumoModuleFragment;
}

export const CarouselPumoModule: React.FC<Props> = ({ carouselPumoModule }) => {
  if (carouselPumoModule.layoutType === 2) {
    return <CarouselPumoModuleGrid carouselPumoModuleGrid={carouselPumoModule} />;
  }

  return <CarouselPumoModuleSlider carouselPumoModuleSlider={carouselPumoModule} />;
};
